<template>
    <div class="download">
      <el-col :span="24" :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="download-box">
            <el-col :span="6" :xs="12" :sm="12" :md="8" :lg="6" :xl="4"  :title="'上传时间：'+news_item.up_time"
              v-for="(news_item, index) in news_list" :key="index" class="download-item-box">
                  <el-row class="title-item p-t8">
                    <el-image 
                      :src="news_item.pic_url"
                      fit="contain" style="    width: 50%;"></el-image>
                  </el-row>
                  <el-row class="title-item p-t8">
                    <b>{{news_item.title}}</b>
                  </el-row>
                  <el-row class="title-item ">
                    <small>适用：{{news_item.apply_to}}</small> 
                    </el-row>
                  <el-row class="title-item-detail m-t8">
                    <small>简介：{{news_item.content}}</small> </el-row>
                  <el-row class="title-item" v-if="news_item.url != ''">
                    <el-link type="primary" :href="news_item.url" target="_blank">点此下载</el-link>
                  </el-row>
            </el-col>

      </el-col>
    </div>
</template>
<script>
export default {
  name: "download",
  data() {
    return {
      news_list:[
        {title:'医生端APP',
        up_time:'2024-06-20 10:19',
        apply_to:'全平台',
        pic_url:require('./images/app-logo.png'),
        content:`医生安卓手机客户端，手机上登录医生账号，可以直接调阅患者影像。支持android 11以上版本.`,
        url:'https://www.imgzo.cn/media/imgzo_doctor_app-release.apk'
        },{
          title:'医生端APP(医院)',
        up_time:'2020-12-31 10:19',
        apply_to:'深圳',
        pic_url:require('./images/app-logo.png'),
        content:`医生安卓手机客户端，支持android 11以上版本.`,
        url:'https://www.imgzo.cn/media/imgzo_doctor_syapp-release.apk'
      },{
          title:'医生端APP(医院)',
        up_time:'2020-12-31 10:19',
        apply_to:'其他区域',
        pic_url:require('./images/app-logo.png'),
        content:`医生安卓手机客户端，支持android 11以上版本.`,
        url:'https://www.imgzo.cn/media/imgzo_doctor_otapp-release.apk'
      }]
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.download {
    background: var(--WhiteColor-1);
    height: calc(100% - var(--footPage) + 8px);
    margin-top: 8px;
    font-size: 14px;
    justify-content: center;
    display: flex;
  overflow: auto;
}
.download .download-box {
  display: flex;
    /* width: 100%; */
    height: 100%;
    color: var(--BlackColor-1);
    flex-direction: row;
    flex-wrap: wrap;
}
.download .download-box .download-item-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 33%;
  padding: 8px;
}
.download .download-box .download-item-box:hover {
  background: var(--SecondColor-10);
}
.download-item-box .newsitem-title-pic {
  overflow: hidden;
}
.download-item-box .newsitem-title-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 8px 16px;
  overflow: hidden;
  line-height: 140%;
  height: 100%;
}
.download-item-box .title-item {
  white-space: nowrap;
  overflow: hidden;
  /* height: 20%; */
}
.download-item-box .title-item-detail {
  /* height: 60%; */
  text-align:left;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>